/** DataTable の pageSize 選択肢（100 始まり）と一致させる */
export const GOVERNMENT_APPLICATION_CONFIRMATION_DEFAULT_PAGE_SIZE = 100;

export const GOVERNMENT_APPLICATION_CONFIRMATION_UNIFIED_STATUSES = [
  'notApplied',
  'failed',
  'withdrawing',
  'withdrawn',
  'returned',
  'correctionPending',
  'completed',
  'inProgress',
] as const;

export type GovernmentApplicationConfirmationUnifiedStatus =
  (typeof GOVERNMENT_APPLICATION_CONFIRMATION_UNIFIED_STATUSES)[number];

export const GOVERNMENT_APPLICATION_CONFIRMATION_ORDER_BY = [
  'target',
  'classification',
  'stepName',
  'status',
  'arriveId',
  'applicationSubmittedAt',
  'dueDate',
  'lastSyncedAt',
] as const;

export type GovernmentApplicationConfirmationOrderBy =
  (typeof GOVERNMENT_APPLICATION_CONFIRMATION_ORDER_BY)[number];

export const GOVERNMENT_APPLICATION_CONFIRMATION_BULK_OPERATIONS = [
  'apply',
  'dataSync',
  'officialDocumentDownload',
] as const;

export type GovernmentApplicationConfirmationBulkOperation =
  (typeof GOVERNMENT_APPLICATION_CONFIRMATION_BULK_OPERATIONS)[number];
